import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckFast } from "@fortawesome/pro-regular-svg-icons";
import { setContentModal, setMainModal } from "../../reducers/slices/main";
import { ShippingCost } from "./shipping_cost";
export const ShippingCostWrapper = () => {
    const dispatch = useDispatch();
    const { address, selection } = useSelector((state) => state.selectionState);
    const { selectedShipping } = selection;
    const toggleModalState = () => {
        if (!address) {
            dispatch(setMainModal({
                title: "No address selected",
                messages: [
                    "Please select an address before choosing your shipping option.",
                    "If you do not have an address, please add an address on the Checkout or Account Details pages.",
                ],
            }));
            return;
        }
        dispatch(setContentModal({
            title: "Shipping Options",
            content: React.createElement(ShippingCost, null),
            showCloseButton: true,
            size: "4xl",
        }));
    };
    return (React.createElement("div", { className: "flex w-full border border-neutral-gray rounded-xl cursor-pointer hover:opacity-60 ease-in-out duration-200 px-4 py-3", onClick: toggleModalState }, selectedShipping?.service_code ? (React.createElement("div", { className: "flex flex-row justify-between items-center w-full" },
        React.createElement("div", { className: "flex flex-row justify-between items-center gap-4" },
            React.createElement(FontAwesomeIcon, { icon: faTruckFast, size: "2xl", className: "text-primary" }),
            React.createElement("div", { className: "flex flex-col justify-start" },
                React.createElement("div", null, selectedShipping?.service_name),
                React.createElement("div", { className: "font-semibold" },
                    "AUD",
                    (selectedShipping?.total_price ?? 0).toFixed(2)))),
        React.createElement("div", { className: "self-start" },
            React.createElement("div", { className: "rounded-full bg-gray text-xs px-2 py-1" }, selectedShipping?.service_code)))) : (React.createElement("div", { className: "flex flex-col justify-between items-center w-full gap-2" },
        React.createElement("div", { className: "flex flex-col justify-center items-center text-dark-gray" }, "Click to see your available shipping options"),
        React.createElement(FontAwesomeIcon, { icon: faTruckFast, size: "2xl", className: "text-primary" })))));
};
